import styled from 'styled-components';
import { BaseAttributeSelector } from '../BaseAttributeSelector/index';
export const StyledFitSelector = styled(BaseAttributeSelector) `
  margin-top: 0;
  margin-bottom: -8px;
  margin-inline-start: 0;
  margin-inline-end: -8px;
`;
//# sourceMappingURL=styles.js.map